import { FormControlType } from '../enums';
import { FieldSizeDescriptor } from './field-size-descriptor';
import { PipeTransform } from '@angular/core';

export class FieldDescriptor {
    name: string;
    caption: string;
    placeholder: string;
    order: number;
    defaultValue: any;
    type: FormControlType;
    sectionId: number;
    data: new () => Object;
    options: any;
    inline: boolean;

    constructor(caption?: string, placeholder?: string, order?: number, defaultValue?: any, type?: FormControlType, sectionId?: number, data?: new () => Object, options?: any, inline?: boolean) {
        this.name = '';
        this.caption = caption || '';
        this.placeholder = placeholder || '';
        this.order = order || 0;
        this.defaultValue = defaultValue || null;
        this.type = type || FormControlType.text;
        this.sectionId = sectionId || 0;
        this.data = data;
        this.options = options;
        this.inline = inline;
    }
}
